import SortDropdown from "./SortDropdown";

const OPTIONS = [
  { value: "newest-first", label: "Newest first" },
  { value: "title", label: "Title" },
  { value: "price", label: "Price" },
  { value: "bid-opening-date", label: "Opening date" },
  { value: "bid-closing-date", label: "Closing date" },
];

const AdSortingDropdown = ({ value, onChange }: any) => (
  <SortDropdown
    label="Sort by"
    options={OPTIONS}
    value={value || "newest-first"}
    onChange={onChange}
  />
);

export default AdSortingDropdown;
